<div class="diary-day">
    <div fxLayout="row" fxLayoutAlign="space-between center" >
        <div class="hour">
            {{ content.fromDate|appDate:'shortTime': '': currentLocale}}
        </div>
        <div class="duration">
            {{ content.totalTime | secondsToDHM:true | default:'-' }}
        </div>
    </div>

    <h2>{{content.name}}</h2>

    <div *ngIf="content.histogramData !== null" class="adn-bar">
        <table-histogram-chart [showOnlyBar]="true"
                               [rows]="content.histogramData.rows"
                               [columns]="content.histogramData.cols"
                               [values]="content.histogramData.values">
        </table-histogram-chart>
    </div>
</div>
